import { forwardRef, type Ref, type SVGProps } from "react";

function SvgStripeCheckmark(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={120}
      height={120}
      fill="none"
      {...props}
    >
      <path
        fill="#635BFF"
        fillRule="evenodd"
        d="M60.5 10c27.614 0 50 22.386 50 50a49.8 49.8 0 0 1-5.442 22.706A15.44 15.44 0 0 0 95 79c-8.56 0-15.5 6.94-15.5 15.5a15.44 15.44 0 0 0 3.706 10.058A49.8 49.8 0 0 1 60.5 110c-27.614 0-50-22.386-50-50s22.386-50 50-50m1.744 23C49.778 33 41.5 39.4 41.5 50.1c0 16.675 23.334 14.025 23.334 21.225 0 2.775-2.463 3.675-5.89 3.675-5.104 0-11.604-2.05-16.759-4.825V84.55C47.899 86.975 53.662 88 58.944 88 71.715 88 80.5 81.775 80.5 70.95c-.102-18-23.486-14.8-23.486-21.575 0-2.35 1.955-3.275 5.205-3.275 4.672 0 10.562 1.4 15.234 3.875v-14.2C72.35 33.775 67.323 33 62.244 33"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M62.244 33C49.778 33 41.5 39.4 41.5 50.1c0 16.675 23.334 14.025 23.334 21.225 0 2.775-2.463 3.675-5.89 3.675-5.104 0-11.604-2.05-16.759-4.825V84.55C47.899 86.975 53.662 88 58.944 88 71.715 88 80.5 81.775 80.5 70.95c-.102-18-23.486-14.8-23.486-21.575 0-2.35 1.955-3.275 5.205-3.275 4.672 0 10.562 1.4 15.234 3.875v-14.2C72.35 33.775 67.323 33 62.244 33"
      />
      <circle cx={95} cy={94.5} r={15} fill="#169563" />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="m90 95.518 3.15 3.011 7.35-8.029"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgStripeCheckmark);
export default ForwardRef;
